import { render, staticRenderFns } from "./ArticlesIndex.vue?vue&type=template&id=a1b91a02&"
import script from "./ArticlesIndex.vue?vue&type=script&lang=js&"
export * from "./ArticlesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports